<template>
  <div class="home">
    <Header />
    <div class="banner">
      <div class="content">
        <el-carousel height="578px" :interval="5000" arrow="always">
          <el-carousel-item>
            <div class="banner__bdground"></div>
            <div class="banner__title">
              科云数字化新零售，让营销执行更有效率
            </div>
            <div class="banner__tips">
              数字驱动运营，打造线上线下数字化、一体化
            </div>
            <div class="btn__box">
              <span class="btn-detail" @click="linkTo('/register')">
                免费试用
              </span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="company__bdground">
      <div class="content bdground">
        <div class="item">
          <div class="icon__box icon-490"></div>
          <div class="text__box">
            <div class="title">全渠道数字化营销领先专家</div>
            <div class="text">
              一云多端全渠道会员管理、任务化精准营销、全渠道中台等核心产品和服务已处于行业领先地位
            </div>
          </div>
        </div>
        <div class="item">
          <div class="icon__box icon-491"></div>
          <div class="text__box">
            <div class="title">阿里云新零售联合解决方案伙伴</div>
            <div class="text">
              携手阿里共同打造快消全渠道会员精准运营联合解决方案，助力零售企业数字化转型
            </div>
          </div>
        </div>
        <div class="item">
          <div class="icon__box icon-492"></div>
          <div class="text__box">
            <div class="title">南天集团成员企业</div>
            <div class="text">
              隶属于南天集团，致力于用科技+行业经验助力零售企业完成线上线下数字化一体化升级
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="platform">
      <div class="content">
        <div class="title">
          数字化营销平台
        </div>
        <div class="title__tips">
          构建营销、交易、服务的全渠道数字化系统闭环
        </div>
        <div class="platform__list">
          <div class="item" @click="selectPlatform(0)">
            <span :class="{ 'item-active': platformActive === 0 }"
              >私域流量运营平台</span
            >
          </div>
          <div class="item" @click="selectPlatform(1)">
            <span :class="{ 'item-active': platformActive === 1 }"
              >全渠道自动化营销平台</span
            >
          </div>
          <div class="item" @click="selectPlatform(2)">
            <span :class="{ 'item-active': platformActive === 2 }"
              >业务中台</span
            >
          </div>
          <div class="item" @click="selectPlatform(3)">
            <span :class="{ 'item-active': platformActive === 3 }"
              >数字中台</span
            >
          </div>
        </div>
        <div class="platform__item" v-show="platformActive === 0">
          <div class="item__img item__img01"></div>
          <div class="item__text">
            <div class="text__title">私域流量运营平台</div>
            <div class="text__tips">
              打通全渠道的会员数据，构建私域流量池，提供全渠道权益共享，打造完整的会员标签体系，实现全渠道会员生命周期的运营。
            </div>
            <div class="btn__box">
              <span
                class="btn-detail"
                @click="linkTo('/service/platform/indexFlowRate')"
              >
                查 看 详 情
              </span>
            </div>
            <div class="other__production">相关产品</div>
            <div class="production__list">
              <div class="production__item">
                <span class="production__img item__img01"></span>
                <span class="production__text">CRM</span>
              </div>
              <div class="production__item">
                <span class="production__img item__img02"></span>
                <span class="production__text">会员通</span>
              </div>
            </div>
          </div>
        </div>
        <div class="platform__item" v-show="platformActive === 1">
          <div class="item__img item__img02"></div>
          <div class="item__text">
            <div class="text__title">全渠道自动化营销平台</div>
            <div class="text__tips">
              基于会员标签体系，定义多样的营销策略，通过使用自动化营销工具和赋能导购辅助营销，完成提升业绩的目标。
            </div>
            <div class="btn__box">
              <span
                class="btn-detail"
                @click="linkTo('/service/platform/indexChannel')"
              >
                查 看 详 情
              </span>
            </div>
            <div class="other__production">相关产品</div>
            <div class="production__list">
              <div class="production__item">
                <span class="production__img item__img01"></span>
                <span class="production__text">导购助手</span>
              </div>
              <div class="production__item">
                <span class="production__img item__img02"></span>
                <span class="production__text">会员通</span>
              </div>
            </div>
          </div>
        </div>
        <div class="platform__item" v-show="platformActive === 2">
          <div class="item__img item__img03"></div>
          <div class="item__text">
            <div class="text__title">业务中台</div>
            <div class="text__tips">
              从整体战略、业务支撑、连接消费者和业务创新等方面进行统筹规划，将业务逻辑进行抽象包装整合，实现后端业务资源到前台易用能力的转化。
            </div>
            <div class="btn__box">
              <span
                class="btn-detail"
                @click="linkTo('/service/middleground/indexBusiness')"
              >
                查 看 详 情
              </span>
            </div>
          </div>
        </div>
        <div class="platform__item" v-show="platformActive === 3">
          <div class="item__img item__img04"></div>
          <div class="item__text">
            <div class="text__title">数据中台</div>
            <div class="text__tips">
              全域数据采集与引入，统一数据资产管理，深度萃取数据价值，智能分析多形态的数据，提供多种智能计算模型
            </div>
            <div class="btn__box">
              <span
                class="btn-detail"
                @click="linkTo('/service/middleground/indexData')"
              >
                查 看 详 情
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="production">
      <div class="content">
        <div class="title">
          科云产品矩阵
        </div>
        <div class="title__tips">
          构建营销、交易、服务的全渠道数字化系统闭环
        </div>
        <div class="production__list">
          <div
            class="production__item production__item01"
            :class="{ 'production__item01-active': productionActive === 0 }"
            @click="setProductionActive(0)"
          >
            <div class="item__name">云CRM</div>
          </div>
          <div
            class="production__item production__item02"
            :class="{ 'production__item02-active': productionActive === 1 }"
            @click="setProductionActive(1)"
          >
            <div class="item__name">云营销</div>
          </div>
          <div
            class="production__item production__item03"
            :class="{ 'production__item03-active': productionActive === 2 }"
            @click="setProductionActive(2)"
          >
            <div class="item__name">小程序商城</div>
          </div>
          <div
            class="production__item production__item04"
            :class="{ 'production__item04-active': productionActive === 3 }"
            @click="setProductionActive(3)"
          >
            <div class="item__name">会员通</div>
          </div>
          <div
            class="production__item production__item05"
            :class="{ 'production__item05-active': productionActive === 4 }"
            @click="setProductionActive(4)"
          >
            <div class="item__name">导购助手</div>
          </div>
          <div
            class="production__item production__item06"
            :class="{ 'production__item06-active': productionActive === 5 }"
            @click="setProductionActive(5)"
          >
            <div class="item__name">POS智能收银</div>
          </div>
        </div>
        <div class="arrow__box">
          <template v-for="(item, index) in 6">
            <i
              class="el-icon-caret-top arrow__item"
              :class="{ 'arrow__item-active': productionActive === index }"
              :key="index"
            ></i>
          </template>
        </div>
        <template v-for="(item, index) in productionData">
          <div
            class="production__detail"
            :key="index"
            v-show="productionActive === index"
          >
            <div class="production__name">
              {{ item.name }}
            </div>
            <div class="production__tips">
              {{ item.tips }}
            </div>
            <div class="detail__list">
              <div
                class="detail__item"
                v-for="(subitem, subIndex) in item.detailList"
                :key="index + '' + subIndex"
              >
                <div class="item__icon"></div>
                <div class="item__name">{{ subitem }}</div>
              </div>
            </div>
            <div class="btn__box">
              <span
                v-if="item.url"
                class="btn-detail"
                @click="linkTo(item.url)"
              >
                了 解 更 多
              </span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="programme">
      <div class="content">
        <div class="title">
          多种智能解决方案
        </div>
        <div class="title__tips">
          线上门店+线下实体店+物流+大数据
        </div>
        <div class="programme__list">
          <div class="item" @click="setProgrammeActive(0)">
            <span :class="{ 'item-active': programmeActive === 0 }"
              >母婴行业解决方案</span
            >
          </div>
          <div class="item" @click="setProgrammeActive(1)">
            <span :class="{ 'item-active': programmeActive === 1 }"
              >美妆行业解决方案</span
            >
          </div>
        </div>
        <div class="card" v-show="programmeActive === 0">
          <el-carousel height="415px" :interval="5000" arrow="always">
            <el-carousel-item>
              <div class="programme__item">
                <div class="left left-01"></div>
                <div class="right">
                  <div class="name">母婴行业解决方案</div>
                  <div class="tips">
                    构建全渠道会员管理和营销的闭环，实现线上线下全渠道的打通，提供全渠道会员的权益共享，统合全渠道的会员进行统一的营销，通过导购辅助营销提升销售，采用云POS保证线上线下的营销同步进行。
                  </div>
                  <div class="case">客户案例</div>
                  <div class="case__list">
                    <div class="case__item case__item01"></div>
                    <div class="case__item case__item02"></div>
                    <div class="case__item case__item03"></div>
                  </div>
                  <div class="btn__box">
                    <span
                      class="btn-detail"
                      @click="linkTo('/programme/indexMI')"
                    >
                      查 看 详 情
                    </span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="card" v-show="programmeActive === 1">
          <el-carousel height="415px" :interval="5000" arrow="always">
            <el-carousel-item>
              <div class="programme__item">
                <div class="left left-02"></div>
                <div class="right">
                  <div class="name">美妆行业解决方案</div>
                  <div class="tips">
                    构建全渠道会员管理和营销的闭环，实现线上线下全渠道的打通，提供全渠道会员的权益共享，统合全渠道的会员进行统一的营销，通过导购辅助营销提升销售，采用云POS保证线上线下的营销同步进行。
                  </div>
                  <!-- <div class="case">客户案例</div>
                  <div class="case__list">
                    <div class="case__item case__item01"></div>
                    <div class="case__item case__item02"></div>
                    <div class="case__item case__item03"></div>
                  </div> -->
                  <div class="btn__box">
                    <span
                      class="btn-detail"
                      @click="linkTo('/programme/indexBM')"
                    >
                      查 看 详 情
                    </span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="content">
        <div class="title">
          国内领先的新零售解决方案专家
        </div>
        <div class="title__tips">
          四大优势助力企业，提高企业营销效率
        </div>
        <div class="advantage__list">
          <div class="item item-active">
            <div class="item__name">丰富业务经验</div>
            <div class="item__space"></div>
            <div class="item__detail">
              团队拥有二十多年的零售业务经验，将多年的传统零售业务经验转化为新零售思想，借鉴多个数据型企业级应用的技术实现运营分析
            </div>
          </div>
          <div class="item">
            <div class="item__name">迭代的全渠道运营场景</div>
            <div class="item__space"></div>
            <div class="item__detail">
              与多个渠道合作，打通全渠道线下线上数据，针对不同的渠道与时俱进的打造多个运营玩法
            </div>
          </div>
          <div class="item">
            <div class="item__name">架构扩展性强</div>
            <div class="item__space"></div>
            <div class="item__detail">
              基于营销中台架构建设，业务和数据可以更好地和其他模块对接，企业可灵活地进行业务扩展和数据融合
            </div>
          </div>
          <div class="item">
            <div class="item__name">强大的新零售生态伙伴</div>
            <div class="item__space"></div>
            <div class="item__detail">
              科云携手阿里，是阿里云新零售首批22家生态合作伙伴之一，依托阿里巴巴的技术及商业资源
            </div>
          </div>
        </div>
        <div class="advantage__total"></div>
      </div>
    </div>
    <div class="enterpriseData">
      <div class="content">
        <div class="title">
          科云营销引擎，助力企业加速
        </div>
        <div class="title__tips">
          打造企业效益增长新引擎
        </div>
        <div class="data__list">
          <div class="item item-active">
            <div class="item__detail">
              <div class="number">1000</div>
              <div class="unit">+个</div>
            </div>
            <div class="item__space"></div>
            <div class="item__title">
              营销活动
            </div>
          </div>
          <div class="item">
            <div class="item__detail">
              <div class="number">800</div>
              <div class="unit">+万</div>
            </div>
            <div class="item__space"></div>
            <div class="item__title">
              活动拉新人数
            </div>
          </div>
          <div class="item">
            <div class="item__detail">
              <div class="number">200</div>
              <div class="unit">+万</div>
            </div>
            <div class="item__space"></div>
            <div class="item__title">
              卡券核销数
            </div>
          </div>
          <div class="item">
            <div class="item__detail">
              <div class="number">30</div>
              <div class="unit">+万</div>
            </div>
            <div class="item__space"></div>
            <div class="item__title">
              忠诚用户转化数
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="experience">
      <div class="content">
        <div class="title">
          开始体验免费套餐
        </div>
        <div class="title__tips">
          注册 即可领取免费体验套餐，为您提供最佳新零售服务解决方案
        </div>
        <div class="btn__box">
          <span class="btn-detail" @click="linkTo('/register')">
            立 即 体 验
          </span>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "home",
  components: { Header, Footer },
  data() {
    return {
      platformActive: 0,
      productionActive: 0,
      productionData: [
        {
          name: "云CRM",
          tips:
            "对会员的所有信息进行管理和分析的系统，助力商家更好沉淀和运营会员",
          detailList: [
            "会员360画像",
            "会员标签",
            "会员分组",
            "会员生命周期",
            "会员余额",
            "会员等级规则"
          ],
          url: ""
        },
        {
          name: "云营销",
          tips:
            "提供各种营销玩法的营销工具和查看各种营销分析的系统，推动商家提升业绩",
          detailList: [
            "自动化营销",
            "内容制作",
            "营销权益管理",
            "营销分析",
            "素材管理"
          ],
          url: ""
        },
        {
          name: "小程序商城",
          tips:
            "提供线上和门店商品销售的小程序微信商城，实现商城线上线下一体化",
          detailList: [
            "分销裂变",
            "拼团",
            "秒杀",
            "配送&提货",
            "线上&线下销售",
            "线下线下引流"
          ],
          url: "/service/retail/indexSmallRoutine"
        },
        {
          name: "会员通",
          tips:
            "公众号上提供会员登录的系统，让用户查询自身所有资料和商家信息的系统，提供用户良好的体验，提升用户忠诚度",
          detailList: [
            "会员资料",
            "消费记录",
            "优惠券",
            "积分",
            "余额",
            "等级权益",
            "附近门店",
            "百科全书",
            "预约活动",
            "活动中心"
          ],
          url: ""
        },
        {
          name: "导购助手",
          tips:
            "提供导购登录的APP，提供导购管理会员，查询业绩，完成任务的助手APP",
          detailList: [
            "导购资料",
            "任务池",
            "邀请会员",
            "推送文章",
            "推送卡券",
            "知识库",
            "排行榜",
            "会员管理",
            "各数据分析"
          ],
          url: ""
        },
        {
          name: "POS智能收银",
          tips:
            "满足移动端和台式PC端的智能收银POS，实现随时快速收银，提升用户购物体验",
          detailList: [
            "商品销售",
            "库存调增",
            "核销优惠券",
            "多渠道收银",
            "多渠道收银"
          ],
          url: ""
        }
      ],
      programmeActive: 0
    };
  },
  methods: {
    selectPlatform(data) {
      this.platformActive = data;
    },
    linkTo(url) {
      this.$router.push({
        path: url
      });
    },
    setProductionActive(data) {
      this.productionActive = data;
    },
    setProgrammeActive(data) {
      this.programmeActive = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  user-select: none;
}
.banner {
  background: rgba(248, 250, 253, 1);
  .el-carousel__item {
    .banner__bdground {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: auto 98%;
      transform-origin: 50% 50%;
      z-index: -1;
      filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
      animation: play 8s linear 1;
    }
    .banner__bdground:nth-of-type(1) {
      background-image: url("../../assets/img/home/2banner-05@2x.png");
    }
    .banner__bdground:nth-of-type(2) {
      background-image: url("../../assets/img/home/2banner-05@2x.png");
    }
    .banner__bdground:nth-of-type(3) {
      background-image: url("../../assets/img/home/2banner-05@2x.png");
    }
    .banner__title {
      padding-top: 212px;
      font-size: 44px;
      font-weight: bold;
      line-height: 62px;
      color: rgba(41, 43, 58, 1);
    }
    .banner__tips {
      padding-top: 14px;
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
      color: rgba(41, 43, 58, 1);
    }
    .btn__box {
      padding-top: 90px;
      .btn-detail {
        display: inline-block;
        text-align: center;
        width: 140px;
        height: 38px;
        border-radius: 19px;
        font-size: 14px;
        font-weight: 400;
        line-height: 38px;
        color: rgba(62, 113, 255, 1);
        border: 1px solid #3e71ff;
        cursor: pointer;
      }
      .btn-detail:hover {
        background: rgba(62, 113, 255, 1);
        box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
        color: rgba(255, 255, 255, 1);
        border: 1px solid rgba(62, 113, 255, 0.2);
      }
    }
  }
}
.company__bdground {
  position: relative;
  z-index: 1;
  height: 140px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.08);
  .bdground {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
      width: 320px;
      padding-left: 40px;
      padding-right: 40px;
      padding-top: 34px;
      height: 106px;
      text-align: left;
      display: flex;
      align-items: flex-start;
      .icon__box {
        display: inline-block;
        width: 64px;
        height: 64px;
        margin-top: 4px;
        margin-right: 10px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }
      .icon-490 {
        background-image: url("../../assets/img/home/490@2x.png");
      }
      .icon-491 {
        background-image: url("../../assets/img/home/491@2x.png");
      }
      .icon-492 {
        background-image: url("../../assets/img/home/492@2x.png");
      }
      .text__box {
        display: inline-block;
        width: 246px;
        .title {
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
        }
        // .title:hover {
        //   color: rgba(62, 113, 255, 1);
        // }
        .text {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          color: rgba(161, 163, 178, 1);
        }
      }
    }
  }
}
.platform {
  padding-top: 120px;
  background: rgba(255, 255, 255, 1);
  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 42px;
    color: rgba(41, 43, 58, 1);
  }
  .title__tips {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: rgba(161, 163, 178, 1);
    padding-top: 12px;
    padding-bottom: 40px;
  }
  .platform__list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(41, 43, 58, 0.1);
    .item {
      width: 285px;
      height: 84px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 400;
      color: rgba(41, 43, 58, 1);
      cursor: pointer;

      .item-active {
        display: inline-block;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border-bottom: solid rgba(62, 113, 255, 1) 2px;
        color: rgba(62, 113, 255, 1);
      }
    }
    // .item-active {
    //   box-sizing: border-box;
    //   border-bottom: solid rgba(62, 113, 255, 1) 2px;
    //   color: rgba(62, 113, 255, 1);
    // }
    .item:hover {
      // box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.08);
    }
  }
  .platform__item {
    padding: 60px 40px 127px 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .item__img {
      display: inline-block;
      width: 480px;
      height: 340px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      // filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
      // animation: play 15s linear infinite;
    }
    .item__img01 {
      background-image: url("../../assets/img/home/721.png");
    }
    .item__img02 {
      background-image: url("../../assets/img/home/248@2x.png");
    }
    .item__img03 {
      background-image: url("../../assets/img/home/228@2x.png");
    }
    .item__img04 {
      background-image: url("../../assets/img/home/610@2x.png");
    }
    .item__text {
      width: 520px;
      padding-top: 20px;
      text-align: left;
      .text__title {
        font-size: 26px;
        font-weight: bold;
        line-height: 37px;
        color: rgba(41, 43, 58, 1);
      }
      .text__tips {
        padding-top: 30px;
        font-size: 14px;
        font-weight: 400;
        line-height: 26px;
        color: rgba(41, 43, 58, 1);
      }
      .btn__box {
        padding-top: 60px;
        padding-bottom: 42px;
        .btn-detail {
          display: inline-block;
          text-align: center;
          width: 140px;
          height: 38px;
          border-radius: 19px;
          font-size: 14px;
          font-weight: 400;
          line-height: 38px;
          color: rgba(62, 113, 255, 1);
          border: 1px solid #3e71ff;
          cursor: pointer;
        }
        .btn-detail:hover {
          background: rgba(62, 113, 255, 1);
          box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
          color: rgba(255, 255, 255, 1);
          border: 1px solid rgba(62, 113, 255, 0.2);
        }
      }
      .other__production {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(41, 43, 58, 1);
      }
      .production__list {
        padding-top: 15px;
        .production__item {
          display: inline-block;
          margin-right: 80px;
          .production__img {
            float: left;
            display: block;
            width: 32px;
            height: 32px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 10px;
          }
          .item__img01 {
            background-image: url("../../assets/img/home/480@2x.png");
          }
          .item__img02 {
            background-image: url("../../assets/img/home/481@2x.png");
          }
          .production__text {
            display: inline-block;
            font-size: 16px;
            font-weight: 400;
            line-height: 32px;
            color: rgba(41, 43, 58, 1);
          }
        }
      }
    }
  }
}
.production {
  padding-top: 120px;
  padding-bottom: 115px;
  background: rgba(248, 250, 253, 1);
  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 42px;
    color: rgba(41, 43, 58, 1);
  }
  .title__tips {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: rgba(161, 163, 178, 1);
    padding-top: 12px;
    padding-bottom: 66px;
  }
  .production__list {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .production__item {
      width: 114px;
      height: 114px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      .item__name {
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(41, 43, 58, 1);
        position: relative;
        margin-bottom: -10px;
      }
    }
    .production__item01 {
      background-image: url("../../assets/img/home/664@2x.png");
    }
    .production__item01-active {
      background-image: url("../../assets/img/home/670@2x.png");
    }
    .production__item02 {
      background-image: url("../../assets/img/home/668@2x.png");
    }
    .production__item02-active {
      background-image: url("../../assets/img/home/678@2x.png");
    }
    .production__item03 {
      background-image: url("../../assets/img/home/669@2x.png");
    }
    .production__item03-active {
      background-image: url("../../assets/img/home/687@2x.png");
    }
    .production__item04 {
      background-image: url("../../assets/img/home/658@2x.png");
    }
    .production__item04-active {
      background-image: url("../../assets/img/home/692@2x.png");
    }
    .production__item05 {
      background-image: url("../../assets/img/home/659@2x.png");
    }
    .production__item05-active {
      background-image: url("../../assets/img/home/704@2x.png");
    }
    .production__item06 {
      background-image: url("../../assets/img/home/663@2x.png");
    }
    .production__item06-active {
      background-image: url("../../assets/img/home/708@2x.png");
    }
    .production__item-active {
    }
    .production__item:hover {
    }
  }
  .arrow__box {
    margin-top: 10px;
    height: 30px;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    .arrow__item {
      display: inline-block;
      font-size: 58px;
      line-height: 22px;
      color: #fff;
      opacity: 0;
    }
    .arrow__item-active {
      opacity: 1;
    }
  }
  .production__detail {
    background: #fff;
    box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.1);
    padding: 62px 80px 60px;
    text-align: left;
    .production__name {
      font-size: 26px;
      font-weight: bold;
      line-height: 37px;
      color: rgba(41, 43, 58, 1);
    }
    .production__tips {
      padding-top: 30px;
      padding-bottom: 20px;
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
      color: rgba(93, 95, 112, 1);
    }
    .detail__list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: flex-start;
      .detail__item {
        margin-right: 20px;
        margin-bottom: 20px;
        width: 192px;
        height: 44px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .item__icon {
          display: inline-block;
          width: 32px;
          height: 32px;
          margin: 0 5px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          background-image: url("../../assets/img/public/499@2x.png");
        }
        .item__name {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(41, 43, 58, 1);
        }
      }
      .detail__item:nth-child(5n) {
        margin-right: 0px;
      }
    }
    .btn__box {
      padding-top: 20px;
      .btn-detail {
        display: inline-block;
        text-align: center;
        width: 140px;
        height: 38px;
        border-radius: 19px;
        font-size: 14px;
        font-weight: 400;
        line-height: 38px;
        color: rgba(62, 113, 255, 1);
        border: 1px solid #3e71ff;
        cursor: pointer;
      }
      .btn-detail:hover {
        background: rgba(62, 113, 255, 1);
        box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
        color: rgba(255, 255, 255, 1);
        border: 1px solid rgba(62, 113, 255, 0.2);
      }
    }
  }
}
.programme {
  padding-top: 120px;
  padding-bottom: 100px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto 100%;
  background-image: url("../../assets/img/home/483@2x.png");
  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 42px;
    color: #fff;
  }
  .title__tips {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: rgba(161, 163, 178, 1);
    padding-top: 12px;
    padding-bottom: 40px;
  }
  .programme__list {
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .item {
      width: 285px;
      height: 84px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;

      .item-active {
        display: inline-block;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        border-bottom: solid rgba(62, 113, 255, 1) 2px;
        color: rgba(62, 113, 255, 1);
      }
    }
    .item:hover {
      box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.08);
    }
  }
  .card {
    width: 960px;
    margin: 0 auto;
    margin-top: 60px;
    .programme__item {
      display: flex;
      justify-content: flex-start;
      justify-content: flex-start;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.1);
      border-radius: 4px;
      .left {
        width: 495px;
        height: 415px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: auto 100%;
      }
      .left-01 {
        background-image: url("../../assets/img/home/195@2x.png");
      }
      .left-02 {
        background-image: url("../../assets/img/home/220@2x.png");
      }
      .right {
        flex: 1;
        padding: 40px 50px 0 40px;
        text-align: left;
        .name {
          font-size: 26px;
          font-weight: bold;
          line-height: 37px;
          color: rgba(41, 43, 58, 1);
        }
        .tips {
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: rgba(41, 43, 58, 1);
        }
        .case {
          margin: 30px 0 10px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(161, 163, 178, 1);
        }
        .case__list {
          display: flex;
          justify-content: flex-start;
          justify-content: flex-start;
          .case__item {
            width: 88px;
            height: 42px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: auto 100%;
          }
          .case__item01 {
            background-image: url("../../assets/img/home/132132@2x.png");
          }
          .case__item02 {
            background-image: url("../../assets/img/home/baby@2x.png");
          }
          .case__item03 {
            background-image: url("../../assets/img/home/babybudding.png");
          }
        }
        .btn__box {
          padding-top: 30px;
          .btn-detail {
            display: inline-block;
            text-align: center;
            width: 140px;
            height: 38px;
            border-radius: 19px;
            font-size: 14px;
            font-weight: 400;
            line-height: 38px;
            color: rgba(62, 113, 255, 1);
            border: 1px solid #3e71ff;
            cursor: pointer;
          }
          .btn-detail:hover {
            background: rgba(62, 113, 255, 1);
            box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
            color: rgba(255, 255, 255, 1);
            border: 1px solid rgba(62, 113, 255, 0.2);
          }
        }
      }
    }
  }
}
.advantage {
  padding-top: 120px;
  padding-bottom: 100px;
  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 42px;
    color: rgba(41, 43, 58, 1);
  }
  .title__tips {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: rgba(161, 163, 178, 1);
    padding-top: 12px;
    padding-bottom: 40px;
  }
  .advantage__list {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    .item {
      padding: 30px;
      width: 520px;
      height: 105px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      margin-bottom: 40px;
      text-align: left;
      box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.08);

      background-repeat: no-repeat;
      background-position: center center;
      background-size: auto 100%;
      background-image: url("../../assets/img/home/483.png");
      // cursor: pointer;
      .item__name {
        font-size: 22px;
        font-weight: bold;
        line-height: 30px;
        color: rgba(41, 43, 58, 1);
      }
      .item__space {
        margin-top: 10px;
        width: 18px;
        height: 3px;
        background: rgba(51, 105, 255, 1);
      }
      .item__detail {
        padding-top: 15px;
        font-size: 14px;
        font-weight: 400;
        line-height: 26px;
        color: rgba(41, 43, 58, 1);
      }
    }
    .item-active {
      color: rgba(62, 113, 255, 1);
    }
  }
  .advantage__total {
    height: 800px;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
    background-image: url("../../assets/img/home/flowchart.png");
  }
}
.enterpriseData {
  padding-top: 60px;
  padding-bottom: 60px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto 100%;
  background-image: url("../../assets/img/home/484@2x.png");
  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 42px;
    color: rgba(255, 255, 255, 1);
  }
  .title__tips {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: rgba(255, 255, 255, 0.6);
    padding-top: 12px;
    padding-bottom: 40px;
  }
  .data__list {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    .item {
      width: 285px;
      border-radius: 8px;
      text-align: left;
      // cursor: pointer;
      .item__detail {
        height: 84px;
        padding-left: 68px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .number {
          display: inline-block;
          font-size: 48px;
          font-weight: 400;
          line-height: 58px;
          color: rgba(255, 255, 255, 1);
        }
        .unit {
          margin-left: 5px;
          display: inline-block;
          font-size: 22px;
          font-weight: 400;
          line-height: 30px;
          color: rgba(255, 255, 255, 0.8);
        }
      }
      .item__space {
        width: 30px;
        height: 4px;
        background: rgba(255, 255, 255, 1);
        margin-left: 68px;
      }
      .item__title {
        padding-top: 14px;
        padding-left: 68px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(255, 255, 255, 1);
      }
    }
    .item-active {
      color: rgba(62, 113, 255, 1);
    }
    .item:hover {
      box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.08);
    }
  }
}
.experience {
  padding-top: 70px;
  padding-bottom: 73px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto 100%;
  background-image: url("../../assets/img/home/328@2x.png");
  .title {
    font-size: 30px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(41, 43, 58, 1);
  }
  .title__tips {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: rgba(41, 43, 58, 1);
    padding-top: 12px;
    padding-bottom: 60px;
  }
  .btn__box {
    .btn-detail {
      display: inline-block;
      text-align: center;
      width: 140px;
      height: 38px;
      border-radius: 19px;
      font-size: 14px;
      font-weight: 400;
      line-height: 38px;
      color: rgba(62, 113, 255, 1);
      border: 1px solid #3e71ff;
      cursor: pointer;
    }
    .btn-detail:hover {
      background: rgba(62, 113, 255, 1);
      box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
      color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(62, 113, 255, 0.2);
    }
  }
}

@keyframes play {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>

<style>
.home .banner .el-carousel__indicator .el-carousel__button {
  width: 80px;
  height: 2px;
  background: rgba(207, 213, 226, 1);
}
.home .banner .el-carousel__indicator.is-active .el-carousel__button {
  background: linear-gradient(
    270deg,
    rgba(50, 116, 251, 1) 0%,
    rgba(50, 116, 251, 0) 100%
  );
}
</style>
<style scoped>
.banner >>> .el-carousel__indicator--horizontal {
  padding: 30px 4px !important;
}
</style>
